import { render, staticRenderFns } from "./contentFieldInvoicesLegend.vue?vue&type=template&id=84c08d90&"
import script from "./contentFieldInvoicesLegend.vue?vue&type=script&lang=js&"
export * from "./contentFieldInvoicesLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports